  angular
  .module('vppApp')
  .service('DTMTrackerService', DTMTrackerService);

  DTMTrackerService.$inject = ['$window', '$rootScope'];

  function DTMTrackerService($window, $rootScope) {
    var dtmTrackerService = {};
    //console.log("DTMTrackerService");
    dtmTrackerService.directCall = function (directCallName) {
      //console.log('directCall ~~ ' + directCallName);
      _satellite.track(directCallName);
    };

    dtmTrackerService.updatePageLoadData = function (varName, varValue) {
      //console.log("updatePageLD ~ " + varName + " : " + varValue);
      $window.digitalData[varName] = varValue;
    };

    return dtmTrackerService;

  }
